$ = require 'jquery'
PopOver = require 'app/scripts/views/lib/pop-over'
Util = require 'app/scripts/lib/util'
View = require 'app/scripts/views/internal/view'
popoverShare = require 'app/scripts/views/templates/popover_share'
{ track, trackUe } = require '@trello/analytics'
{ dontUpsell } = require '@trello/config'
Controller = require 'app/scripts/controller'
Auth = require 'app/scripts/db/auth'
React = require 'react'
ReactDOM = require '@trello/react-dom-wrapper'
{ renderComponent } = require 'app/src/components/ComponentWrapper'
print = require('app/common/lib/util/print').default
{ UpgradePromptFull } = require 'app/src/components/UpgradePrompts'
l = require 'app/scripts/lib/localize'
{ IconName } = require 'app/common/components/controls'

module.exports = class SharePopoverView extends View
  viewTitleKey: 'print and export'

  events:
    'click .js-print': 'printModel'
    'click .js-export-json': 'exportJSON'
    'click .js-export-csv': 'exportCSV'

  render: ->
    view = @
    org = @model.getOrganization()

    data = @model.toJSON()
    data.hasCsvExport = false

    data.hasOrganization = @model.hasOrganization()
    data.upgradeUrl = Controller.getUpgradeUrl(@model)
    data.isAdDismissed = Auth.me().isAdDismissed('share-popover')

    if org? && org?.isFeatureEnabled('csvExport')
      data.hasCsvExport = true
      data.csvURL = "/b/#{ @model.get('shortLink') }.csv"

    if org?.isPremium() && !org?.isFeatureEnabled('csvExport')
      data.needsUpgradeForCsv = true

    data.jsonURL = "/b/#{ @model.get('shortLink') }.json"

    data.upsellEnabled = !dontUpsell

    @$el.html(popoverShare(data))

    isFreeTeam = org && !org.isPremium()

    if !data.isAdDismissed && !dontUpsell && isFreeTeam
      billingUrl = @getBillingUrl(org)

      $printAndExportUpgradePromptWrapper = @$('.print-and-export-upgrade-prompt-wrapper')[0]
      renderComponent(@adContainer(billingUrl, $printAndExportUpgradePromptWrapper), $printAndExportUpgradePromptWrapper)

    @

  getBillingUrl: (org) ->
    if org
      return Controller.getOrganizationBillingUrl(org)
    return '/business-class'

  adContainer: (billingUrl, reactRoot) ->
    React.createElement(
      React.Fragment,
      null,
      React.createElement('hr', null),
      @upgradePrompt(billingUrl, reactRoot)
    )

  upgradePrompt: (billingUrl, reactRoot) ->
    React.createElement(
      UpgradePromptFull, {
        content: l(['upgrade prompt', 'board menu', 'print and export', 'content-2'])
        headline: l(['upgrade prompt', 'board menu', 'print and export', 'headline-2'])
        cta: l(['upgrade prompt', 'learn more'])
        ctaLink: billingUrl
        ctaTrackEvent: => trackUe(
          'board menu',
          'opens',
          'team page bc tab',
          '',
          '',
          'by clicking full upgrade prompt in the board menu export page'
        )
        iconName: IconName.Download
        isDismissable: true
        onDismiss: ->
          ReactDOM.unmountComponentAtNode(reactRoot)
          Auth.me().dismissAd('share-popover')
      }
    )

  printModel: (e) ->
    Util.stop(e)

    track('Board Menu', 'Print and Export Menu', 'Print')
    PopOver.hide()

    @defer ->
      print()

    return

  exportJSON: (e) ->
    track('Board Menu', 'Print and Export Menu', 'Export JSON')

  exportCSV: (e) ->
    track('Board Menu', 'Print and Export Menu', 'Export CSV')
